import React, { useState, useEffect, useRef } from 'react';

const AnimateOnScroll = ({ children, direction = 'up', delay = 0 }) => {
    const [isVisible, setIsVisible] = useState(false);
    const ref = useRef(null);
    const directionClasses = { up: 'translate-y-20', down: '-translate-y-20', left: '-translate-x-20', right: 'translate-x-20' };
    const initialClasses = `opacity-0 ${directionClasses[direction]}`;
    const finalClasses = 'opacity-100 translate-y-0 translate-x-0';
    
    // Custom CSS for the smooth transition (Butter Smooth Fix)
    const transitionStyle = { 
        transition: 'all 1500ms cubic-bezier(0.23, 1, 0.32, 1)', // Increased duration and soft easing
        transitionDelay: `${delay}ms` 
    };

    useEffect(() => {
        const observer = new IntersectionObserver(([entry]) => {
            setIsVisible(entry.isIntersecting);
        }, { threshold: 0.1 });
        const currentRef = ref.current;
        if (currentRef) observer.observe(currentRef);
        return () => { if (currentRef) observer.unobserve(currentRef) };
    }, []);
    
    return (
        <div ref={ref} className={`${isVisible ? finalClasses : initialClasses}`} style={transitionStyle} >
            {children}
        </div>
    );
};

export default AnimateOnScroll;